export const COURSES_ENDPOINT =
	'https://us-central1-euneos-cms-prod.cloudfunctions.net/api/courses';

export const INSTANCES_ENDPOINT =
	'https://us-central1-euneos-prod.cloudfunctions.net/api/courses/instances';

export const CATEGORIES_ENDPOINT =
	'https://us-central1-euneos-cms-prod.cloudfunctions.net/api/categories';

export const IMAGE_PATH = 'https://d2e7mwkxl97hcv.cloudfront.net/';

/**
 * List of countries with their corresponding flag
 * @type {object}
 */
export const COUNTRIES_LIST = {
	'N/A': 'albania',
	'N/A': 'andorra',
	'N/A': 'armenia',
	'N/A': 'austria',
	'N/A': 'azerbaijan',
	'N/A': 'belarus',
	'N/A': 'belgium',
	'N/A': 'bosnia-herzegovina',
	'N/A': 'bulgaria',
	'N/A': 'croatia',
	'N/A': 'cyprus',
	'N/A': 'czechia',
	'N/A': 'denmark',
	EE: 'estonia',
	FI: 'finland',
	FIEE: 'finland-estonia',
	'N/A': 'france',
	'N/A': 'germany',
	'N/A': 'georgia',
	GR: 'greece',
	'N/A': 'hungary',
	'N/A': 'iceland',
	'N/A': 'ireland',
	'N/A': 'italy',
	'N/A': 'latvia',
	'N/A': 'liechtenstein',
	'N/A': 'lithuania',
	'N/A': 'luxembourg',
	'N/A': 'malta',
	'N/A': 'moldova',
	'N/A': 'monaco',
	'N/A': 'montenegro',
	'N/A': 'netherlands',
	MK: 'north-macedonia',
	'N/A': 'norway',
	'N/A': 'poland',
	PT: 'portugal',
	'N/A': 'romania',
	'N/A': 'russia',
	'N/A': 'san-marino',
	'N/A': 'serbia',
	'N/A': 'slovakia',
	'N/A': 'slovenia',
	ES: 'spain',
	'N/A': 'sweden',
	'N/A': 'switzerland',
	'N/A': 'turkey',
	'N/A': 'ukraine',
	'N/A': 'united-kingdom',
	'N/A': 'vatican-city',
};
